import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, FormGroup, Input } from "reactstrap";
import { Btn, H3, P } from "../../../AbstractElements";
import { emailValidationSchema } from "../../../Schema/ForgotPassword";
import {
  CreateAccount,
  DoNotAccount,
  LoginRoute,
} from "../../../utils/Constant";

interface FormData {
  email: string;
}

export const EmailAddressForm = ({
  setStep,
  email,
  setEmail,
}: {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const navigate = useNavigate();
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(emailValidationSchema),
  });

  const onSubmit = async (data: FormData) => {
    try {
      console.log(email);

      setEmail(data.email);
      setStep(2);

      toast.success("Enter the OTP code sent to your email address");
    } catch (err) {
      if (err instanceof Error) toast.error(err.message);
      else toast.error("Password reset failed. Please try again.");
    }
  };

  return (
    <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
      <H3>{"Forgot Password"}</H3>
      <P>{"Provide your email to receive the OTP Code"}</P>
      <FormGroup>
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <Input
              type="email"
              placeholder="Enter your email address"
              {...field}
            />
          )}
        />
        {errors.email && <p className="text-danger">{errors.email.message}</p>}
      </FormGroup>

      <FormGroup className="mb-0 form-sub-title">
        <Link to={`/${LoginRoute}`}>
          {"Do you remember the password? Sign In"}
        </Link>
        <div className="text-end mt-3">
          <Btn color="primary" type="submit" block className="w-100">
            Next
          </Btn>
        </div>
      </FormGroup>
      <P className="mt-4 mb-0 text-center">
        {DoNotAccount}
        <Link className="ms-2" to="/authentication/register_simple">
          {CreateAccount}
        </Link>
      </P>
    </Form>
  );
};
